import { HtmlValidationException } from "../../exceptions/html-validation-exception";
import { Microservice } from "../../model/microservice";
import { BaseChainableBobComponent } from "../base-chainable-bob-component";
import { IProcessable } from "../pipeline/processable.interface";

export class HtmlValidatorComponent extends BaseChainableBobComponent<Microservice> implements IProcessable<Microservice> {

	/**
	 * Starts with the validation of the object passed along.
	 *
	 * @param input
	 */
	public async process(input: Microservice) {

		this.validateHTML(input);
		return await this.next.process(input);
	}

	/**
	 * Validates that the given HTML is a snippet and not a document.
	 *
	 * @param input
	 */
	private validateHTML(input: Microservice): void {

		if (input.html.indexOf("<html>") > -1) {

			this.tracker.trackEvent({
				url: "",
				category: "Microservice",
				action: "RequestFailed",
				label: "InvalidDocument"
			});

			this.throwException("not a valid html snippet");
		}
	}

	/**
	 * Throws a custom exception to stop the current pipeline.
	 *
	 * @param type
	 */
	private throwException(type: string): any {

		throw new HtmlValidationException(type);
	}
}
